import * as classnames from 'classnames/bind'
import * as moment from 'moment'
import * as React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Dispatch, RootState, select, store } from 'src/store'
import Avatar from '../Avatar'
import Icon from '../Icon'
import navbarStyles from '../Navbar/navbar.scss'
import styles from './remindDropdown.scss'

const cx = classnames.bind({
  ...styles,
  ...navbarStyles
})

interface IProps
  extends ReturnType<typeof mapState>,
  ReturnType<typeof mapDispatch> { }

const RemindDropdown: React.SFC<IProps> = ({
  notifications,
  onReadNotification,
  onReadAllNotification
}) => (
    <div className={cx('navbar__remind-list', 'remind-list', 'active')}>
      <div className={cx('remind-list__fixed-bar')}>
        <h3 className={cx('title')}>通知列表</h3>
        <a href="#!" className={cx('read-btn')} onClick={onReadAllNotification}>
          全部標示為已讀
      </a>
      </div>
      <ul
        className={cx({
          'remind-list__inner': notifications.length > 0 ? true : false
        })}
      >
        {notifications.length > 0 ? (
          notifications.map(payload => {
            const { notification, notificationId } = payload
            let duration = ''
            const diff = moment.duration(
              moment().diff(moment.unix(notification.ts.seconds)) / 1000,
              'second'
            )
            if (diff.years()) {
              duration = `${diff.years()} 年前`
            } else if (diff.months()) {
              duration = `${diff.months()} 月前`
            } else if (diff.weeks()) {
              duration = `${diff.weeks()} 週前`
            } else if (diff.days()) {
              duration = `${diff.days()} 天前`
            } else if (diff.hours()) {
              duration = `${diff.hours()} 小時前`
            } else if (diff.minutes()) {
              duration = `${diff.minutes()} 分鐘前`
            } else if (diff.seconds()) {
              duration = `${diff.seconds()} 秒前`
            } else {
              duration = `不到一秒前`
            }

            return (
              <li
                className={cx('remind-list__item', {
                  active: notification.read === false
                })}
                key={notificationId}
              >
                <Link
                  className={cx('remind-list__link')}
                  to={notification.link}
                  onClick={onReadNotification.bind(null, notificationId)}
                >
                  <Avatar className={cx('remind-avatar')} />
                  <div className={cx('remind-list__info')}>
                    <p
                      className={cx('text')}
                      dangerouslySetInnerHTML={{
                        __html: notification.text.replace(/\n/g, '<br/>')
                      }}
                    />
                    <p className={cx('time')}>
                      <span>{duration}</span>
                    </p>
                  </div>
                </Link>
              </li>
            )
          })
        ) : (
            <div className={cx('icon_empty')}>
              <Icon className={cx('icon-empty')} type="empty" />
              <p className={cx('icon_empty-text')}>尚未收到任何通知</p>
            </div>
          )}
      </ul>
    </div>
  )

const mapState = ({ notifications }: RootState) => {
  const rootState = store.getState()
  return {
    notifications: select.notifications.getNotifications(rootState)
  }
}

const mapDispatch = (dispatch: Dispatch) => {
  const rootState = store.getState()
  return {
    onReadNotification: (notificationId: string) =>
      dispatch.notifications.updateNotification({
        notificationId,
        updated: { read: true }
      }),
    onReadAllNotification: () =>
      select.notifications.getNotifications(rootState).map(payload =>
        dispatch.notifications.updateNotification({
          notificationId: payload.notificationId,
          updated: { read: true }
        })
      )
  }
}

export default connect(
  mapState,
  mapDispatch
)(RemindDropdown)



// WEBPACK FOOTER //
// ./src/components/RemindDropdown/index.tsx